import TimePicker from 'antd/es/time-picker';

export default TimePicker;
